import { render, staticRenderFns } from "./FlightLookup.vue?vue&type=template&id=f6b72892"
import script from "./FlightLookup.vue?vue&type=script&setup=true&lang=ts"
export * from "./FlightLookup.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports